<template lang="pug">
div
  portal(v-if="dialogId" :to="`${dialogId}.${$dialogs.slots.content}`")
    p.ui-body-1 К сожалению, при работе в браузере Safari могут возникать ошибки, препятствующие нормальной работе в системе. Рекомендуем использовать мобильное приложение.
  portal(v-if="dialogId" :to="`${dialogId}.${$dialogs.slots.actions}`" v-slot="{ close }")
    .d-flex.flex-column.gap-12.full-width
      dv-btn(
        :href="$conf.APPLICATION_APPLE"
        target="_blank"
        rel="noopener noreferrer"
        large
        @click="close"
      ) Скачать приложение
      dv-btn(
        text
        large
        @click="close"
      ) Продолжить на сайте

</template>

<script>
import DvBtn from '@/packages/ui/components/buttons/DvBtn.vue';

let shownInCurrentSession = false;

export default {
  name: 'MobileDialogSafari',
  components: { DvBtn },
  data() {
    return {
      dialogId: undefined,
    };
  },
  mounted() {
    if (this.$conf.isMobileSafari && !shownInCurrentSession) {
      this.openDialog();
    }
  },
  beforeDestroy() {
    if (this.dialogId && this.$dialogs.has(this.dialogId)) {
      this.$dialogs.close(this.dialogId);
    }
  },
  methods: {
    openDialog() {
      if (this.dialogId && this.$dialogs.has(this.dialogId)) return;
      this.dialogId = this.$dialogs.portal({
        attrs: {
          title: 'Мобильное приложение',
          'max-width': 600,
          'card-attrs': { class: 'ui-design' },
        },
        listeners: {
          close: () => { this.dialogId = undefined; },
        },
      });
      shownInCurrentSession = true;
    },
  },
};
</script>
